module.exports = "<list-view\n  active-params=\"$ctrl.activeParams\"\n  filter-event=\"$ctrl.filterEvent\"\n  page=\"$ctrl.page\"\n  limit=\"$ctrl.limit\"\n  resource=\"PrivateBusRequests\"\n  item-state=\"privatebusrequest\"\n  title=\"Private Bus Requests\"\n  transformer=\"PrivateBusRequestsTransforms\"\n  paginate-event=\"$ctrl.paginateEvent\"\n  no-items-text=\"No Private Bus Requests Yet!\"\n></list-view>\n\n<main-footer></main-footer>\n<main-sidenav sections=\"$ctrl.sections\">\n  <main-sidenav></main-sidenav>\n</main-sidenav>\n";


//////////////////
// WEBPACK FOOTER
// ./src/pages/privateBusRequests/privateBusRequests.html
// module id = 1933
// module chunks = 0